import { FC, useState } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ExpandableLongText.translations.json';
import { TextEllipsis } from './TextEllipsis';

const { addTranslations, useTranslation } = i18nNsFactory(
  'expandable-long-text'
);
addTranslations(translations);

type ExpandableLongTextProps = (
  | {
      id?: never;
      rows?: number;
      hideExpandButton: true;
    }
  | {
      id: string;
      rows?: number;
      hideExpandButton?: never | false;
    }
) & {
  children: string;
};

export const ExpandableLongText: FC<ExpandableLongTextProps> = ({
  id,
  children,
  rows = 1,
  hideExpandButton = false,
}) => {
  const { t } = useTranslation();
  const [enableEllipsis, setEnableEllipsis] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {expanded ? (
        children
      ) : (
        <TextEllipsis rows={rows} onIsClipped={setEnableEllipsis}>
          {children}
        </TextEllipsis>
      )}
      {children && enableEllipsis && !hideExpandButton && (
        <ShowMoreButton
          id={`${id}-toggle-show-more`}
          type="link"
          size="small"
          onClick={() => setExpanded(!expanded)}
        >
          {t(`show.${expanded ? 'less' : 'more'}`)}
        </ShowMoreButton>
      )}
    </>
  );
};

const ShowMoreButton = styled(Button)`
  padding: 0 !important;
`;
